export default __webpack_public_path__ + "static/media/64.5649b9b6.png";